export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_SHORT = 'DD/MM/YY';
export const SEGMENT_DATE_FORMAT = 'YYYYMMDD';
export const ACCEPTED_DATE_FORMATS = ['DD/MM/YYYY', 'D/M/YYYY', 'DD/M/YYYY', 'D/MM/YYYY'];
export const POUNDS_PER_KILOGRAM = 2.2046;
export const THIRTY_DAYS_IN_MILLISECONDS = 2_592_000;
export const THREE_SECONDS_IN_MILLISECONDS = 3_000;

export const INTERNAL_API_KEY_HEADER_NAME = 'x-internal-api-key';
export const VERSION_HASH_HEADER_KEY = 'x-version-hash';
export const UTM_PARAMS_HEADER_KEY = 'x-utm-params';
export const NON_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/;
